import script from "./UndoToast.vue?vue&type=script&setup=true&lang=js"
export * from "./UndoToast.vue?vue&type=script&setup=true&lang=js"

import "./UndoToast.vue?vue&type=style&index=0&id=1fbfa95e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbfa95e"]])

export default __exports__